<script lang="ts" setup>
interface Props {
  modelValue: unknown
}

const props = defineProps<Props>()

const source = computed<string>(() => props.modelValue ? JSON.stringify(props.modelValue, null, 4) : 'null')

const { copy, copied, isSupported } = useClipboard({ source })

const store = useAppStore()

const { displayDebug } = storeToRefs(store)
</script>

<template>
  <div
    v-if="displayDebug"
    class="dev-json"
  >
    <UIDynamicHeading
      level="4"
      as="h4"
      class="dev-json__title"
    >
      <slot name="title" />
    </UIDynamicHeading>
    <div class="dev-json__container">
      <textarea
        class="dev-json__textarea"
        :value="source"
        readonly
      />
      <UIButton
        v-if="isSupported"
        prepended-icon="fluent:copy-16-filled"
        class="dev-json__copy"
        variant="outlined"
        @click="copy()"
      >
        {{ copied ? 'Copied' : 'Copy' }}
      </UIButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.dev-json {
  @apply w-full block relative;

  &__title {
    @apply mb-2;
  }

  &__container {
    @apply relative;
  }

  &__textarea {
    @apply bg-black text-sm text-white w-full h-[300px]
  }

  &__copy {
    @apply absolute right-1 top-1 z-10;
  }
}
</style>
